import * as React from "react";
import {TherapyInvite} from "../therapy-invite";
// import {Dialog, DialogTitle, DialogContent, DialogActions, Button} from "@mui/material";
import {useTranslation} from "react-i18next";

import {Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField} from '@mui/material';
import {useState} from "react";
import api from "../../../api/api";
import {Toast} from "react-toastify/dist/components";
import {toast} from "react-toastify";
import YellowButton from "../../../common/buttons/YellowButton";
import SecondaryButton from "../../../common/buttons/SecondaryButton";
import {trackInviteCreated} from "../../../../analytics/events";


interface InviteDetailsProps {
    createPopupOpen: any;
    setCreatePopupOpen: any;
}

const CreateInvite: React.FC<InviteDetailsProps> = ({createPopupOpen, setCreatePopupOpen}) => {
    const {t} = useTranslation();
    const [inviteeName, setInviteeName] = useState('');
    const [comment, setComment] = useState('');
    const handleClose = () => {
        setCreatePopupOpen(false);
    }
    const createInvite = async () => {
        if(!inviteeName) {
            toast.error(t("Please enter invitee name"));
            return;
        }
        let postData:any = {inviteeName: inviteeName};
        if(comment) {
            postData.comment = comment;
        }
        await api().post('invites', postData);
        trackInviteCreated();
        toast.success(t("Invite has been created successfully"));
        setInviteeName("");
        setComment("");
        handleClose();
    }
    return (
        <Dialog open={createPopupOpen} onClose={handleClose}>
            <DialogTitle>{t("Please add information to create new invite")}</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    required
                    margin="dense"
                    id="invitee-name"
                    label={t("Invitee Name")}
                    type="text"
                    fullWidth
                    value={inviteeName}
                    onChange={(e) => setInviteeName(e.target.value)}
                />

                <TextField
                    margin="dense"
                    id="comment"
                    label={t("Comment")}
                    type="text"
                    fullWidth
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                />
            </DialogContent>

            <DialogActions>
                <YellowButton onClick={createInvite}>
                    {t("Create")}
                </YellowButton>

                <SecondaryButton onClick={handleClose}>
                    {t("Cancel")}
                </SecondaryButton>
            </DialogActions>
        </Dialog>
    );

}

export default CreateInvite;